import { render, staticRenderFns } from "./DocumentListItem.vue?vue&type=template&id=f2b32e16"
import script from "./DocumentListItem.vue?vue&type=script&lang=js"
export * from "./DocumentListItem.vue?vue&type=script&lang=js"
import style0 from "./DocumentListItem.vue?vue&type=style&index=0&id=f2b32e16&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports